export default "__VITE_ASSET__a358a9a5__"